export default function initLightbox(modalId) {
  const modalWrapper = document.getElementById(modalId);
  const modal = modalWrapper.querySelector(".nioomi-modal");
  const modalCloser = modalWrapper.querySelector(".nioomi-modal__closer");
  const modalOverlay = modalWrapper.querySelector(".nioomi-modal__overlay");

  document
    .querySelectorAll(`[data-modal-id="${modalId}"]`)
    .forEach((trigger) => {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        modal.classList.add("nioomi-modal-enter");
        modalWrapper.classList.add("overlay--open");
        setTimeout(() => {
          modal.classList.add("nioomi-modal-enter-done");
        }, 250);
      });
    });
  function close(event) {
    event.preventDefault();
    modal.classList.add("nioomi-modal-exit");
    setTimeout(() => {
      modalWrapper.classList.remove("overlay--open");
      modal.classList.remove("nioomi-modal-enter");
      modal.classList.remove("nioomi-modal-enter-done");
      modal.classList.remove("nioomi-modal-exit");
    }, 240);
  }
  modalCloser && modalCloser.addEventListener("click", close);
  modalOverlay && modalOverlay.addEventListener("click", close);
}
